module.exports = __webpack_public_path__ + "static/media/sv.26ee8872.svg";